import {
  INVENTORY_ITEM_H,
  INVENTORY_ITEM_STEP_Y,
  INVENTORY_OFFSET_X,
  INVENTORY_OFFSET_Y,
  GRID_BLOCK_SIDE_LEN,
  COLORS,
} from "./shared_constants";
import { InputEnum } from "../input_manager";
import { randomInt } from "../random";

export default class Inventory {
  #hasFocus = false;
  #focusTime = 0;
  #shapes = [];

  cursorIndex = 0;
  onRun = () => {};
  onExit = (gridPos) => {};
  onSelection = (shape) => {};

  giveFocus() {
    this.#hasFocus = true;
    this.#focusTime = 0;
  }

  removeFocus() {
    this.#hasFocus = false;
    this.#focusTime = 0;
  }

  setShapes(shapes) {
    shapes.forEach((shape) => {
      shape.x = Math.floor(GRID_BLOCK_SIDE_LEN / 2);
      shape.y = Math.floor(GRID_BLOCK_SIDE_LEN / 2);
      shape.rotation = randomInt(4);
    });

    this.#shapes = shapes;
  }

  addShape(shape) {
    shape.x = Math.floor(GRID_BLOCK_SIDE_LEN / 2);
    shape.y = Math.floor(GRID_BLOCK_SIDE_LEN / 2);
    this.#shapes.push(shape);
  }

  update(inputManager, delta) {
    this.#focusTime += delta;

    if (inputManager.justPressed(InputEnum.LEFT)) {
      this.onExit(this.cursorIndex);
      return;
    }

    const pressedUp =
      inputManager.justPressed(InputEnum.UP) ||
      inputManager.justRepeated(InputEnum.UP);

    const pressedDown =
      inputManager.justPressed(InputEnum.DOWN) ||
      inputManager.justRepeated(InputEnum.DOWN);

    if (pressedUp) {
      this.cursorIndex -= 1;
    }
    if (pressedDown) {
      this.cursorIndex += 1;
    }

    if (inputManager.justPressed(InputEnum.START)) {
      this.cursorIndex = this.#shapes.length;
    }

    this.cursorIndex = Math.max(0, this.cursorIndex);
    this.cursorIndex = Math.min(this.#shapes.length, this.cursorIndex);

    if (inputManager.justPressed(InputEnum.A)) {
      if (this.cursorIndex < this.#shapes.length) {
        const [removedShape] = this.#shapes.splice(this.cursorIndex, 1);
        this.onSelection(removedShape);
      } else {
        this.onRun();
      }
    }
  }

  render(ctx) {
    ctx.font = "16px bn6-bold";
    ctx.textBaseline = "top";
    const width = 38;
    const height = INVENTORY_ITEM_H;

    for (let i = 0; i < this.#shapes.length; i++) {
      const shape = this.#shapes[i];

      const startX = INVENTORY_OFFSET_X;
      const startY = INVENTORY_OFFSET_Y + INVENTORY_ITEM_STEP_Y * i;

      // render border
      ctx.fillStyle = COLORS.BORDER;
      ctx.fillRect(startX, startY, width, height);

      // render bg
      ctx.fillStyle = COLORS.GRID_BACKGROUND;
      ctx.fillRect(startX + 2, startY + 2, width - 4, height - 4);

      // render mini shape
      ctx.fillStyle = shape.color;
      for (let x = 0; x < 5; x++) {
        for (let y = 0; y < 5; y++) {
          if (!shape.existsAt(x, y)) continue;

          ctx.fillRect(startX + x * 3 + 18, startY + y * 3 + 2, 3, 3);
        }
      }

      ctx.fillStyle = "white";
      ctx.fillText(shape.letter, startX + 6, startY + 2);
    }

    // render run button
    {
      const startX = INVENTORY_OFFSET_X;
      const startY =
        INVENTORY_OFFSET_Y + INVENTORY_ITEM_STEP_Y * this.#shapes.length;

      // render border
      ctx.fillStyle = COLORS.BORDER;
      ctx.fillRect(startX, startY, width, height);

      // render bg
      ctx.fillStyle = "lime";
      ctx.fillRect(startX + 2, startY + 2, width - 4, height - 4);

      ctx.fillStyle = "white";
      ctx.fillText("RUN", startX + 6, startY + 3);
    }

    if (this.#hasFocus) {
      const startX = Math.floor(
        INVENTORY_OFFSET_X - 9 + Math.sin(this.#focusTime * 16) * 1.5
      );
      const startY =
        INVENTORY_OFFSET_Y + INVENTORY_ITEM_STEP_Y * this.cursorIndex;

      ctx.strokeStyle = COLORS.INVENTORY_CURSOR_LIGHT;
      ctx.fillStyle = COLORS.INVENTORY_CURSOR_MID;
      ctx.beginPath();
      ctx.moveTo(startX + 0.5, startY + 2);
      ctx.lineTo(startX + 8.5, startY + height / 2);
      ctx.lineTo(startX + 0.5, startY + height - 2);
      ctx.stroke();
      ctx.closePath();
      ctx.fill();
    }
  }
}
